import { message } from "antd";
import { useState } from "react";
import { careerPathService } from "Services/AdminServices/Organization/CareerPathService";

export const useCareerPath = () => {
  const [loading, setLoading] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [careerPath, setCareerPath] = useState(null);
  const [jobTitles, setJobTitles] = useState([]);
  const [loadingJobs, setLoadingJobs] = useState(false);
  const [skills, setSkills] = useState([]);
  const [loadingSkills, setLoadingSkills] = useState(false);
  const [domains, setDomains] = useState([]);
  const [loadingDomains, setLoadingDomains] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    departmentId: 0,
    domainKnowledgeIds: [],
  });

  const createCareerPath = async (payload) => {
    try {
      setLoading(true);
      const res = await careerPathService.createCareerPath(payload);
      return res;
    } catch (error) {
      const serverMessage =
        error?.response?.data?.details || error?.response?.data?.message || "Server Error";

      message.error(serverMessage);
    } finally {
      setLoading(false);
    }
  };

  const updateCareerPath = async (payload) => {
    try {
      setLoading(true);
      const res = await careerPathService.updateCareerPath(payload);
      return res;
    } catch (error) {
      console.log("Error in Updating", error);
      message.error(error?.response?.data?.details);
    } finally {
      setLoading(false);
    }
  };

  const fetchCareerPath = async (id) => {
    try {
      setLoadingEdit(true);
      const data = await careerPathService.getCareerPath(id);
      console.log("C..................areer path", data);
      setCareerPath(data);
      fetchSkills(careerPath.departmentId);
    } catch (error) {
      console.error("Error fetching Career Path", error);
    } finally {
      setLoadingEdit(false);
    }
  };

  const fetchSkills = async (departmentId) => {
    try {
      setLoadingSkills(true);
      const data = await careerPathService.getSkills(departmentId);
      console.log("skills", data);
      setSkills(data);
    } catch (err) {
      console.error("Error fetching Skills", err);
    } finally {
      setLoadingSkills(false);
    }
  };

  const createJobTitle = async (payload) => {
    try {
      console.log("payload", payload);
      const response = await careerPathService.createJobTitle(payload);
      return response;
    } catch (error) {
      const serverMessage =
        error?.response?.data?.details || error?.response?.data?.message || "Server Error";
      message.error(serverMessage);

      console.error("Error in creating Job Title", error);
    }
  };

  const fetchDomains = async () => {
    try {
      setLoadingDomains(true);
      const data = await careerPathService.getDomains();
      setDomains(data);
      console.log("Domains", data);
    } catch (error) {
      console.error("Error in fetching Domains", error);
    } finally {
      setLoadingDomains(false);
    }
  };

  return {
    formData,
    setFormData,
    createCareerPath,
    updateCareerPath,
    fetchCareerPath,
    careerPath,
    loading,
    loadingEdit,
    fetchSkills,
    skills,
    loadingSkills,
    jobTitles,
    loadingJobs,
    createJobTitle,

    loadingDomains,
    domains,
    fetchDomains,
  };
};
